import type { VocabEntry } from "../context/types";
import { OptionGroup } from "./OptionGroup";

type ChipSelectorProps = {
  options: VocabEntry[];
  value: string | null;
  /**
   * Prevents interaction with all non-selected options
   */
  disabled?: boolean;
  /**
   * When false, clicking the selected option does nothing (radio behavior).
   * When true (default), clicking the selected option deselects it.
   */
  allowDeselect?: boolean;
  onValueChange: ({ value }: { value: string | null }) => void;
};

export function ChipSelector({
  options,
  value,
  disabled,
  allowDeselect,
  onValueChange,
}: ChipSelectorProps) {
  return (
    <OptionGroup
      options={options.map((option) => ({
        id: option.id,
        label: option.label_nl,
      }))}
      value={value}
      disabled={disabled}
      allowDeselect={allowDeselect}
      onValueChange={onValueChange}
    />
  );
}
